import { Router } from 'react-router-dom';

import { utilities as useCases } from 'core/use-cases';
import { history } from 'core/use-cases/utilities';

import { store, persistor } from '../store';

import { Intl } from './Intl';

const { PersistGate, Provider: StoreProvider } = useCases;

export default function Provider({ children }: { children: React.ReactNode }) {
  return (
    <StoreProvider store={store}>
      <PersistGate persistor={persistor}>
        <Intl>
          <Router history={history}>{children}</Router>
        </Intl>
      </PersistGate>
    </StoreProvider>
  );
}
